import containersCtls from './containers/index';
import baseCtls from './baseCtls/index';
import dataCtls from './dataCtls/index';
import tableRelCtls from './tableRelCtls/index';
import bpmFlowCtls from './bpmFlowCtls/index';
import htmlParse from './htmlParse/index';

export default {
  ...htmlParse,
  ...tableRelCtls,
  ...dataCtls,
  ...containersCtls,
  ...baseCtls,
  ...bpmFlowCtls,
}
